import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AddOn } from '@compumark/analyst-selection-tool-client';
import { CustomTextFilterComponent } from '@compumark/brand-context-components';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { GridApi, GridOptions } from 'ag-grid-community';
import { debounceTime, fromEvent } from 'rxjs';
import { FilterParams } from 'src/app/results/services/filters.params';
import { WCLAddOnPopupLinkComponent } from '../wcl-addon-popup-link/wcl-addon-popup-link.component';

@UntilDestroy()
@Component({
  selector: 'app-wcl-addons',
  standalone: false,
  templateUrl: './wcl-addons.component.html',
  styleUrls: ['./wcl-addons.component.scss'],
})
export class WCLAddOnsComponent implements OnInit {
  gridApi!: GridApi;
  rowData: AddOn[] = [];

  readonly gridOptions: GridOptions = {
    suppressHeaderFocus: true,
    getRowId: (t) => t.data.id,
    getRowHeight: () => 35,
    rowModelType: 'clientSide',
    enableCellTextSelection: true,
    suppressHorizontalScroll: false,
    suppressMovableColumns: true,
    suppressCellFocus: true,
    suppressRowClickSelection: true,
    detailRowAutoHeight: true,
    overlayLoadingTemplate: '<span></span>',

    columnDefs: [
      {
        headerName: 'Add-On ID',
        field: 'id',
        filter: 'textColumnFilterWithoutOptions',
        filterParams: FilterParams.textFilterParams,
        menuTabs: ['filterMenuTab'],
        width: 50,
      },
      {
        headerName: 'Add-On Description (EN)',
        field: 'descriptionEN',
        filter: 'textColumnFilterWithoutOptions',
        menuTabs: ['filterMenuTab'],
        filterParams: FilterParams.textFilterParams,
        resizable: true,
        minWidth: 120,
      },
      {
        headerName: 'Add-On Description (FR)',
        field: 'descriptionFR',
        filter: 'textColumnFilterWithoutOptions',
        menuTabs: ['filterMenuTab'],
        filterParams: FilterParams.textFilterParams,
        resizable: true,
        minWidth: 120,
      },
      {
        headerName: 'Websites',
        width: 50,
        sortable: false,
        filter: false,
        cellRenderer: 'wclAddOnPopupLinkComponent',
      },
      {
        headerName: 'Print Settings',
        field: 'printSetting',
        menuTabs: [],
        width: 50,
        cellDataType: 'text',
        valueFormatter: (params) => (params.value ? 'True' : 'False'),
      },
    ],

    components: {
      textColumnFilterWithoutOptions: CustomTextFilterComponent,
      wclAddOnPopupLinkComponent: WCLAddOnPopupLinkComponent,
    },

    onGridReady: (event) => {
      this.gridApi = event.api;

      this.gridApi.setGridOption('rowData', this.rowData);

      event.api.sizeColumnsToFit();

      fromEvent(window, 'resize')
        .pipe(untilDestroyed(this), debounceTime(250))
        .subscribe(() => {
          event.api.sizeColumnsToFit();
        });
    },
  };

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.rowData = this.route.snapshot.data.data.addOns;
  }
}
